import { useEffect, useMemo, useState } from 'react';

import { loginPageService } from '@/state/login-page.service';
import { useAppState } from '@/state/hooks/app.state.hook';

interface AuthHelpLinkProps {
  on?: boolean;
  text?: string;
  url?: string;
  testId: string;
  ariaLabel?: string;
}

export const AuthHelpLink = ({
  on,
  text,
  url,
  testId,
  ariaLabel,
}: AuthHelpLinkProps): React.ReactElement | null => {
  const { initialBoot } = useAppState();
  const [isWebview, setIsWebview] = useState(false);

  useEffect(() => {
    setIsWebview(loginPageService.isWebviewBrowser());
  }, []);

  const showHelpLink = useMemo((): boolean => {
    return !!(url && text && on && !isWebview);
  }, [url, text, on, isWebview]);

  if (!showHelpLink) return null;

  const fontColor = initialBoot?.theme?.loginPopup?.fontColor || '#FFF';

  return (
    <div
      className="flex w-full flex-col items-center text-center text-base underline"
      data-testid={testId}
    >
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel}
        style={{ color: fontColor }}
      >
        {text}
      </a>
    </div>
  );
};
